"use strict";

(function () {
  'use strict';

  angular.module('lr.Properties.Services', []).factory('PropertiesFactory', PropertiesFactory);
  PropertiesFactory.$inject = ['$http', '$q', 'User', 'api', 'authErrors', 'PropertyStateValue', 'formFilters', '$filter'];
  /* @ngInject */

  function PropertiesFactory($http, $q, User, api, authErrors, PropertyStateValue, formFilters, $filter) {
    var Properties = {};
    var isBusy = false;
    var DEFAULTS = {
      page: 0,
      pageSize: 25
    };
    angular.extend(Properties, DEFAULTS);
    /**
     * Page through the properties
     * @param page the current page
     * @param size the amount of properties we want
     * @returns {*}
     */

    Properties.getDefaultProperties = function (page, size) {
      var deferred = $q.defer();

      if (isBusy) {
        isBusy = false;
        return deferred.reject([]);
      }

      isBusy = true;
      var pageNum = page;
      var pageSize = size;

      if (User.isAuthenticated()) {
        var user = User.getToken();
        var url = '/reservations/Property/List/' + user.AdminCustDataID + '?start=' + pageNum * pageSize + '&pageSize=' + pageSize;
        $http.get(api.proxy + url, {
          cache: true
        }).success(function (data, status) {
          if (status === 200 || data.status === 200) {
            deferred.resolve(data);
          } else {
            deferred.reject(data);
          }

          isBusy = false;
          deferred.resolve(data);
        }).error(function (data) {
          isBusy = false;
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };
    /**
     *
     * @param page
     * @param size
     * @param date
     * @param filterStateType
     * @param filtersData
     * @returns {*}
     */


    Properties.pageProperties = function (page, size, date, filterStateType, filtersData) {
      if (isBusy) {
        return $q.reject('Busy');
      }

      isBusy = true;
      var pageNum = page;
      var pageSize = size;
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        var sendData = angular.extend({}, filtersData);

        if (filterStateType) {
          sendData[filterStateType] = true;
        } //sendData['AdminCustDataID'] = user.AdminCustDataID;


        sendData['QueryDate'] = $filter('date')(date, 'M/d/yyyy');
        sendData['Start'] = pageNum * pageSize;
        sendData['PageSize'] = pageSize;
        var url = '/Reservations/Property/State/Search';
        $http.post(api.proxy + url, sendData, {
          cache: true
        }).success(function (data, status) {
          if (status === 200 || data.status === 200) {
            deferred.resolve(data);
          } else {
            deferred.reject(data);
          }

          isBusy = false;
          deferred.resolve(data);
        }).error(function (data) {
          isBusy = false;
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };
    /**
     *
     * @returns {promise}
     */


    Properties.getProperties = function () {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        $http.get(api.proxy + '/reservations/property/allforpartner/' + user.AdminCustDataID + '/' + Properties.offset + '/' + Properties.pageSize, {
          cache: true
        }).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };
    /**
     *
     * @param pageDataID
     * @returns {promise}
     */


    Properties.getDetails = function (pageDataID, optDate) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        $http.post(api.proxy + '/Reservations/Property/Details/' + user.AdminCustDataID + '/' + pageDataID, {
          queryDate: optDate
        }, {
          cache: true
        }).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };
    /**
     *
     * @param pageDataID
     * @returns {promise}
     */


    Properties.getNotes = function (transactionId) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        $http.get(api.proxy + '/reservations/transaction/notes/' + user.AdminCustDataID + '/' + transactionId, {
          cache: true
        }).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };
    /**
     *
     * @param args
     * @returns {promise}
     */


    Properties.stateOverride = function (args) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken();
        var sendData = {
          adminCustDataID: user.AdminCustDataID,
          PageDataID: args.PageDataID,
          stateType: args.stateType,
          newState: args.newState,
          reason: args.reason,
          overriddingResUserID: user.ResUserID,
          overriddingUsersIPAddress: user.ClientIP
        };
        $http.post(api.proxy + '/Reservations/Property/State/Override', sendData).then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };
    /**
     *
     * @param pageDataID
     * @returns {promise}
     */


    Properties.getReadiness = function (pageDataID) {
      var deferred = $q.defer();

      if (User.isAuthenticated()) {
        var user = User.getToken(); //todo: readiness url

        $http.get(api.proxy + 'URL').then(function (data) {
          deferred.resolve(data);
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject(authErrors.notAuthenticated);
      }

      return deferred.promise;
    };
    /**
     *
     * @param imageObject
     * @param index
     * @param size
     * @returns {string}
     */


    Properties.buildImageLink = function (imageObject, index, size) {
      var picSize = size ? size : 250;
      return 'https://cdn.liverez.com/5/' + imageObject.AdminCustDataID + '/1/' + imageObject.PageDataID + '/' + picSize + '/' + index + '.jpg';
    };

    return Properties;
  }
})();